import { useNode } from "@craftjs/core";
import React, { useContext, useMemo, useState } from "react";
import TextareaInput from "../../ui-kit/textarea";
import TextInput from "../../ui-kit/text";

import {
  PencilActiveIcon,
  LeftALignIcon,
  LeftALignActiveIcon,
  CenterAlignIcon,
  CenterAlignActiveIcon,
  RightAlignIcon,
  RightAlignActiveIcon,
  PhotoIcon,
  JustifyIcon,
  JustifyActiveIcon,
  AlignContentCenterIcon,
  AlignContentTopIcon,
  AlignContentTopActiveIcon,
  AlignContentCenterActiveIcon,
  AlignContentEndIcon,
  AlignContentEndActiveIcon,
} from "../../../assets/ui-icons";
import { isUpdatedFromDefault } from "../../utils";

import {
  ColorInput,
  MarginInput,
  OptionsInput,
  PaddingInput,
  Panel,
  RangeInput,
  SpacerInput,
  Tabs,
  ToggleInput,
} from "./../../ui-kit";
import RightBar from "../../ui-kit/rightbar";
import { IconPack } from "../../../assets/icon-pack";
import { GrigoraDashboardContext } from "../../dashboard/context";
import { INPUT_LIMITS } from "../../input-limits";

export const CMSPortalCloseSettings = () => {
  const {
    actions: { setProp },
    props,
    id,
  } = useNode((node) => ({
    text: node.data.props.text,
    props: node.data.props,
  }));

  const [srcModal, setSrcModal] = useState(false);
  const {
    align,
    alignTablet,
    alignMobile,
    alignVertical,
    alignVerticalTablet,
    alignVerticalMobile,
    width,
    widthTablet,
    widthMobile,
    height,
    heightTablet,
    heightMobile,
    background,
    color,
    boxShadow,
    border,
    borderRadius,
    margin,
    marginTablet,
    marginMobile,
    padding,
    paddingTablet,
    paddingMobile,
    hoverBackground,
    hoverColor,
    hoverBoxShadow,
    hoverBorder,
    hoverBorderRadius,
    hoverMargin,
    hoverMarginTablet,
    hoverMarginMobile,
    hoverPadding,
    hoverPaddingTablet,
    hoverPaddingMobile,
  } = props;
  const { projectID } = useContext(GrigoraDashboardContext);

  const General = () => {
    return (
      <>
        <SpacerInput>
          <RangeInput
            min={INPUT_LIMITS["portal-width"].minlength}
            max={INPUT_LIMITS["portal-width"].maxlength}
            value={width}
            onChange={(val) => {
              setProp((props) => {
                props.width = val + "%";
              });
            }}
            label={"Width"}
          />
          <RangeInput
            min={INPUT_LIMITS["portal-height"].minlength}
            max={INPUT_LIMITS["portal-height"].maxlength}
            value={height}
            onChange={(val) => {
              setProp((props) => {
                props.height = val + "px";
              });
            }}
            label={"Height"}
          />
          <OptionsInput
            label={"Horizontal Align"}
            value={align}
            onChange={(val) => {
              setProp((props) => {
                props.align = val;
              });
            }}
            options={[
              {
                label: "Justify",
                value: "justify",
                icon: <JustifyIcon width={"20px"} />,
                active: <JustifyActiveIcon width={"20px"} />,
              },
              {
                label: "Left",
                value: "left",
                icon: <LeftALignIcon width={"20px"} />,
                active: <LeftALignActiveIcon width={"20px"} />,
              },
              {
                label: "Center",
                value: "center",
                icon: <CenterAlignIcon width={"20px"} />,
                active: <CenterAlignActiveIcon width={"20px"} />,
              },
              {
                label: "Right",
                value: "right",
                icon: <RightAlignIcon width={"20px"} />,
                active: <RightAlignActiveIcon width={"20px"} />,
              },
            ]}
          />
          <OptionsInput
            label={"Vertical Align"}
            value={alignVertical}
            onChange={(val) => {
              setProp((props) => {
                props.alignVertical = val;
              });
            }}
            options={[
              {
                label: "Top",
                value: "top",
                icon: <AlignContentTopIcon width={"20px"} />,
                active: <AlignContentTopActiveIcon width={"20px"} />,
              },
              {
                label: "Center",
                value: "center",
                icon: <AlignContentCenterIcon width={"20px"} />,
                active: <AlignContentCenterActiveIcon width={"20px"} />,
              },
              {
                label: "Bottom",
                value: "bottom",
                icon: <AlignContentEndIcon width={"20px"} />,
                active: <AlignContentEndActiveIcon width={"20px"} />,
              },
            ]}
          />
        </SpacerInput>
      </>
    );
  };
  const Styles = () => {
    return (
      <Panel label={"Colors"} isOpen={true}>
        <SpacerInput>
          <ColorInput
            value={color}
            onChange={(val) => {
              setProp((props) => {
                props.color = val;
              });
            }}
            label={"Color"}
            useTextColorPalette={true}
          />
          <ColorInput
            value={background}
            onChange={(val) => {
              setProp((props) => {
                props.background = val;
              });
            }}
            label={"Background"}
            useTextColorPalette={true}
          />
        </SpacerInput>
      </Panel>
    );
  };
  const Advance = () => {
    return (
      <SpacerInput>
        <MarginInput
          value={margin}
          onChange={(val) => {
            setProp((props) => {
              props.margin = val;
            });
          }}
        />
        <PaddingInput
          value={padding}
          onChange={(val) => {
            setProp((props) => {
              props.padding = val;
            });
          }}
        />
      </SpacerInput>
    );
  };
  const tabs = [
    {
      label: "General",
      key: "general",
      icon: IconPack.GeneralSettings,
      children: General(),
      isUpdated: isUpdatedFromDefault([]),
    },
    {
      label: "Style",
      key: "style",
      icon: IconPack.Style,
      children: Styles(),
      isUpdated: isUpdatedFromDefault([]),
    },
    {
      label: "Advance",
      key: "advance",
      icon: IconPack.Advance,
      children: Advance(),
      isUpdated: isUpdatedFromDefault([]),
    },
  ];

  return (
    <div className="h-full w-[330px] post-edit-right-sidebar p-2 cursor-default overflow-auto dashboard-ui-scrollbar ">
      <div className="w-full rounded-t-[21px] bg-white">
        <div className="p-5 flex justify-between">
          <RightBar title={"Image"} icon={<PhotoIcon />} />
        </div>

        <Tabs id={`block-cms-settings-tab-${id}`} items={tabs} />

        <div className="py-2 bg-ui-light-white"></div>
      </div>
    </div>
  );
};
